import { NavigationGuard } from 'vue-router'
import useUser from '@/composables/useUser'
import { useModalStore, Modal } from '@/store/pinia/modalStore'

export const userCanAccessPowerEdit: NavigationGuard = (
    _to,
    _from,
    next
) => {
    if (useUser().enabledPowerEdit3.value) {
        return next()
    }
    useModalStore().openModal(Modal.PowerEditUpgradeModal)
    next(false)
}
